import DetailPreview from "../../../../../components/Preview/DetailPreview";
import { getStyle } from "../../../../../hooks/use-styles";
import { prepareProductDetail } from "../../product-detail-utils";

const DetailView = ({ product, materialName }) => {
  const { accessory } = product.containerOption;
  return (
    <div className="detail-view-container">
      <DetailPreview
        inlineFlex={true}
        className={`product-detail-preview-items ${
          accessory ? "product-detail-modal-content" : ""
        }`}
        detailInfo={prepareProductDetail({
          product,
          materialName,
        })}
        labelClass={"font-16-normal-400-lh-22 capitalize"}
        valueClass={"font-16-normal-400-lh-22 capitalize"}
        labelStyle={{ color: getStyle("secondaryGray") }}
        valueStyle={{ color: getStyle("black") }}
      />
    </div>
  );
};

export default DetailView;
